import { useStore } from '@/store';
import BasketService from '@/services/basketService';

export function useBasket() {
    // Usings
    const store = useStore();

    // Services
    const basketService = new BasketService();

    async function createBasket() {
        if (store.currentUser && store.currentUser.email && store.currentDebitor) {
            try {
                const res = await basketService.CreateBasket(store.currentUser.email, store.currentDebitor.debitorNumber);
                store.currentDebitor.basketGuid = res.data;
                // Update the basket in the store
                await getBasket();
            } catch (error) {
                console.error("Failed to create basket", error);
            }
        }
    }

    async function getBasket() {
        if (!store.currentDebitor) {
            store.basket = undefined;
            return;
        }

        if (store.currentDebitor.basketGuid) {
            try {
                const response = await basketService.GetBasket(store.currentDebitor.basketGuid);
                store.basket = response.data;
            } catch (error: any) {
                if (error.response?.status === 404) {
                    // Basket not found, create a new one
                    await createBasket();
                }
            }
        } else {
            await createBasket();
        }
    }

    return {
        getBasket,
        createBasket
    };
}
